export const PALETTE_DICTIONARY = {
  blank: 'white',
  default: 'gray',
  error: 'red',
  info: 'blue',
  orange: 'orange',
  primary: 'blue',
  success: 'green',
  warning: 'yellow'
}
